<template>
    <header class="page-header">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h2 v-if="admin">{{admin.name}}</h2>
                    <h2 v-if="merchant">{{merchant.name}}</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="row pb-3">
                        <div class="col-md-12 d-flex flex-row">
                            <select class="form-control analytics-header-select mr-3" @change="updatePaymentType($event)">
                                <option value="0">Прием</option>
                                <option value="1">Выплаты</option>
                            </select>
                            <ul class="nav nav-pills mr-3">
                                <li class="nav-item">
                                    <button :disabled="loading" :class="'nav-link ' + (type === 'today' ? 'active' : '')" @click="updateData('today')">Сегодня</button>
                                </li>
                                <li class="nav-item">
                                    <button :disabled="loading" :class="'nav-link ' + (type === 'week' ? 'active' : '')" @click="updateData('week')">Неделя</button>
                                </li>
                                <li class="nav-item">
                                    <button :disabled="loading" :class="'nav-link ' + (type === 'month' ? 'active' : '')" @click="updateData('month')">Месяц</button>
                                </li>
                            </ul>

                            <VueCtkDateTimePicker class="datepicker analytics-header-datepicker mr-3"
                                                  v-model="daterange"
                                                  lang="ru"
                                                  color="purple"
                                                  :range="true"
                                                  format="YYYY-MM-DD"
                                                  formatted="YYYY-MM-DD"
                                                  output-format="YYYY-MM-DD"
                                                  :noHeader="true"
                                                  :noShortcuts="true"
                                                  :button-color="'#8a689e'"
                                                  :minute-interval="60"
                                                  :max-date="this.rangeMaxDate"
                                                  :only-date="true"
                                                  :button-now-translation="'Сегодня'"
                                                  :autoClose="true"
                                                  label="Период" />
                            <select
                                    v-if="admin"
                                    v-model="merchantId"
                                    @change="updateMerchantId($event)"
                                    class="form-control analytics-header-select mr-3"
                            >
                                <option v-for="merchant in admin.merchants" :key="merchant.id" :value="merchant.id">{{merchant.name}}</option>
                            </select>

                            <template v-if="window.location.pathname !== '/admin/financial-report'">
                                <select
                                        class="form-control analytics-header-select mr-3"
                                        v-model="acquiringId"
                                        @change="updateAcquiringId($event)"
                                >
                                    <option value="0">Все банки</option>
                                    <option
                                            v-for="acquiring in acquirings"
                                            :key="acquiring.id"
                                            :value="acquiring.id"
                                    >
                                        {{ acquiring['name'] }}
                                    </option>
                                </select>
                                <select
                                        v-model="mpsId"
                                        @change="updateMpsId($event)"
                                        class="form-control analytics-header-select mr-3"
                                >
                                    <option value="0">Все МПС</option>
                                    <option v-for="mps in mpses" :value="mps.value">{{mps.name}}</option>
                                </select>
                                <select
                                    v-model="acquirerId"
                                    @change="updateAcquirerId($event)"
                                    class="form-control analytics-header-select mr-3"
                                >
                                    <option value="0">Все Эквайеры</option>
                                    <option v-for="acquirer in acquirers" :value="acquirer.value">{{acquirer.name}}</option>
                                </select>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    import moment from 'moment';
    import {mapState} from 'vuex'

    import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';

    export default {
        name: "AnalyticsHeader",
        data () {
            return {
                type: 'week',
                paymentType: 0,
                daterange: null,
                rangeMaxDate: null,
                acquirings: [],
                mpses: [
                    {value: 4, name: 'Visa'},
                    {value: 5, name: 'MasterCard/Maestro'},
                    {value: 3, name: 'American Express'},
                    {value: 67, name: 'Maestro'},
                    {value: 6, name: 'UnionPay'},
                    {value: 2, name: 'Mir'},
                ],
                acquirers: [
                    {value: 1, name: 'Epay'},
                    {value: 2, name: 'Alfa'},
                ],
                window: window
            };
        },
        components: {
            VueCtkDateTimePicker
        },
        mounted() {
            this.rangeMaxDate = moment().format('YYYY-MM-DD');
        },
        computed: {
            loading () {
                return this.$store.state.loading > 0
            },
            ...mapState({
                admin: state => state.admin,
                merchant: state => state.merchant,
                merchantId: state => state.merchantId,
                acquiringId: state => state.acquiringId,
                mpsId: state => state.mpsId,
                acquirerId: state => state.acquirerId
            }),
        },
        created() {
            if(window.location.pathname === '/admin/financial-report') {
                this.generateFinReport();
            } else {
                this.getBanks();
            }
            this.getAdmin();
            this.getMerchant();
        },
        methods: {
            getAdmin() {
                this.$store.commit('setLoading', 1);
                axios.get('/admin/show')
                    .then((response) => {
                        if (response.data !== null) {
                            this.$store.commit('setAdmin', response.data);
                            this.$store.commit('unsetLoading')
                        }
                    })
                    .catch(() => {
                        this.$store.commit('unsetLoading')
                    });
            },
            getMerchant() {
                this.$store.commit('setLoading', 1);
                axios.get('/admin/merchant')
                    .then((response) => {
                        if (response.data.data !== null) {
                            this.$store.commit('setMerchant', response.data.data);
                        }
                        this.$store.commit('unsetLoading')
                    })
                    .catch(() => {
                        this.$store.commit('unsetLoading')
                    });
            },
            updateData(type) {
                this.type = type;
                let date = '';
                switch (type) {
                    case 'today': date = moment().format('YYYY-MM-DD'); break;
                    case 'week': date = moment().subtract(7,'d').format('YYYY-MM-DD'); break;
                    case 'month': date = moment().subtract(1,'months').format('YYYY-MM-DD'); break;
                }
                this.$store.commit('setFilteDateFrom', { filterType: type, dateFrom: date, dateTo: moment().format('YYYY-MM-DD')})
            },

            updatePaymentType(event) {
                this.$store.commit('setFilterPaymentType', event.target.value);
            },
            updateMerchantId(e) {
                this.$store.commit('setMerchantId', e.target.value);
            },
            getBanks() {
                this.$store.commit('setLoading', 1);
                axios.get('/admin/payment/acquiring')
                    .then(response => {
                        if (response.data !== null) {
                            this.acquirings = response.data;
                        }
                        this.$store.commit('unsetLoading');
                    })
                    .catch(() => {
                        this.$store.commit('unsetLoading');
                    });
            },
            updateAcquiringId(e) {
                this.$store.commit('setAcquiringId', e.target.value);
            },
            updateMpsId(e) {
                this.$store.commit('setMpsId', e.target.value);
            },
            updateAcquirerId(e) {
                this.$store.commit('setAcquirerId', e.target.value);
            },
            generateFinReport() {
                this.$store.commit('setLoading', 1);
                axios.get('/admin/financial-report')
                    .then(() => {
                        this.$store.commit('unsetLoading');
                    })
                    .catch(()=> {
                        this.$store.commit('unsetLoading');
                    });
            }
        },
        watch: {
            daterange(val) {
                if (val != null && val.start != null && val.end != null) {
                    this.type = 'period';
                    this.$store.commit('setFilteDateFrom', {filterType: 'period',dateFrom: val.start, dateTo: val.end} );
                } else {
                    this.$store.commit('setFilteDateFrom', {filterType: null, dateFrom: null, dateTo: null} );
                }
            }
        }
    }
</script>

<style scoped>

</style>
